import { jsx } from '@amazon/vinyl-tsx'
import { getTopModal } from '@/components/modalLayer'

/**
 * Single host for the app-level modal stack. Mounted once at the
 * AppView root; subscribes to `getTopModal()` and renders whatever
 * node is on top. Callers don't need to manage portals or
 * containment — they just call `openModal({ render })` and the host
 * places the resulting node in the right spot in the DOM tree
 * (above page content, below header/transport via the existing
 * `.modal { z-index: 1000 }` rule).
 */
export function ModalLayer() {
    return (
        <div
            className="modalLayer"
            onConnect={(view) => {
                return getTopModal().onData((node) => {
                    view.innerHTML = ''
                    if (node) view.appendChild(node)
                })
            }}
        />
    )
}
